MST.deepMerge = function (target, src) {
  let dst = {};

  if (target && typeof target === "object") {
    Object.keys(target).forEach(function (key) {
      dst[key] = target[key];
    });
  }

  if (src) {
    Object.keys(src).forEach(function (key) {
      if (
        src[key] instanceof Array ||
        typeof src[key] !== "object" ||
        !src[key]
      ) {
        dst[key] = src[key];
      } else {
        if (!target[key]) {
          dst[key] = src[key];
        } else {
          dst[key] = MST.deepMerge(target[key], src[key]);
        }
      }
    });
  }

  return dst;
};

MST.globalViewConfig = {
  layout: { paddingLeft: 2, paddingRight: 2, paddingTop: 25, paddingBottom: 2 },
  vAxis: { width: 55, decimals: 0, textClassName: "yAxis" },
  hAxis: { height: 17, textClassName: "xAxis" },
  panel: { gridColor: "#DCDCDC" },
};
MST.viewConfig = {
  main: {
    layout: { height: 260 },
    vAxis: { parts: 4 },
  },
  sub: {
    layout: { height: 100 },
    vAxis: { parts: 2 },
  },
};
MST.scrollConfig = {
  showScroll: false,
};
MST.technicalConfig = {
  candle: {
    dataColor: [0],
    dataColorLabel: ["name"],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_URL,
    dataName: "close",
    labels: [
      { label: "open", data: "open" },
      { label: "high", data: "high" },
      { label: "low", data: "low" },
      { label: "close", data: "close" },
    ],
  },
  mountain: {
    projectorType: "line",
    dataColor: [0],
    dataFillcolor: ["#4572A7"],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_URL,
    dataName: "close",
    labels: [{ label: "close", data: "close" }],
  },
  line: {
    projectorType: "line",
    dataColor: [0],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_URL,
    dataName: "close",
    labels: [{ label: "close", data: "close" }],
  },
  fundLine: {
    type: "main",
    projectorType: "line",
    cancellable: false,
    dataColor: [12],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN,
    dataName: "dividend",
    labels: [{ label: "dividend", data: "dividend" }],
  },
  intraday: {
    projectorType: "line",
    colorIsConstant: true,
    dataColor: ["#0070bf", "#FF0000", "#008000"],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_URL,
    dataName: "close",
    labels: [{ label: "close", data: "close" }],
  },
  twoDays: {
    layout: { height: 280 },
    projectorType: "line",
    dataColor: [0],
    dataFillcolor: ["#4572A7"],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_URL,
    dataName: "close",
    labels: [{ label: "close", data: "close" }],
  },
  volume: {
    type: "sub",
    colorIsConstant: true,
    dataColor: ["#95A5B1"],
    dataColorSelect: ["#95A5B1"],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN,
    dataName: "volume",
    labels: [{ label: "volume", data: "volume" }],
  },
  MACD: {
    type: "sub",
    projectorType: "line",
    dataColor: [6, 7],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_ANALYSIS,
    analysis: MACD,
    params: [12, 24, 26],
    paramLabels: ["emaShort", "emaLong", "signal"],
    paramMaxLengths: [3, 3, 3],
    labels: [
      { label: "MACD", data: "resultMACD" },
      { label: "signal", data: "resultMACDSignal" },
    ],
  },
  Momentum: {
    type: "sub",
    projectorType: "line",
    dataColor: [6, 7],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_ANALYSIS,
    analysis: MOMENTUM,
    params: [10],
    paramLabels: ["period"],
    paramMaxLengths: [3],
    labels: [{ label: "Momentum", data: "resultMo" }],
  },
  Kairi: {
    type: "sub",
    labelShowParam: true,
    projectorType: "line",
    dataColor: [5],
    dataColorLabel: [],
    loadType: MST.SvgChartTechnical.DATA_ANALYSIS,
    analysis: KAIRI,
    params: [75],
    paramLabels: ["period"],
    paramMaxLengths: [3],
    labels: [{ label: "Kairi", data: "result" }],
  },
};

MST.SvgChartConfig = function () {
  let controllerConfig = {
    timeFrame: "1Y",
    showController: false,
    showIndicator: false,
    showBenchmark: false,
    showChartRange: false,
    showUpdateBrowser: false,
    showType: false,
    showReset: false,
    layout: {
      height: 30,
    },
    ranges: ["2D", "1W", "1M", "3M", "6M", "YTD", "1Y", "5Y", "10Y"],
    indicators: ["Kairi", "Momentum", "MACD"],
  };
  let actionViewConfig = { active: true, panel: { crossColor: "#96c5e3" } };

  let config = {
    type: "PC",
    technicalList: [["line"], ["volume"]],
    controller: controllerConfig,
    scroll: MST.deepMerge(MST.globalViewConfig, MST.scrollConfig),
    actionView: actionViewConfig,
    globalViewConfig: MST.globalViewConfig,
    viewConfig: MST.viewConfig,
    technicalConfig: MST.technicalConfig,
  };

  return config;
};
